function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: 1,
  d: "M0 1.14343L7 8L14 1.14343L12.8335 0L7 5.71475L1.16653 0L0 1.14343Z",
  fill: "#385CAD"
});

const Svg1 = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 8,
  viewBox: "0 0 14 8",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/1.ce391e10.svg";
export { ForwardRef as ReactComponent };